import { useState } from "react";
import BackButton from "../../../../components/Button/BackButton";
import SelectMenu from "../../../../components/Form/SelectMenu";
import { FIELD_BASE, fieldState } from "../../../../components/Form/formFieldStyles";
import { btn } from "../../../../components/Button/buttonStyles";

const HEADERS = ["Reminder", "Send"];

const YES_NO = [
  { value: "yes", label: "Yes" },
  { value: "no", label: "No" },
];

const RemindersForm = ({ reminders, onSave, onCancel }) => {
  const [rows, setRows] = useState(reminders.map((r) => ({ ...r })));
  const [saving, setSaving] = useState(false);

  const setEnabled = (type, enabled) =>
    setRows((prev) =>
      prev.map((r) => (r.reminder_type === type ? { ...r, enabled } : r))
    );

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    const ok = await onSave({
      reminders: rows.map((r) => ({ reminder_type: r.reminder_type, enabled: r.enabled })),
    });
    setSaving(false);
    if (ok) onCancel();
  };

  return (
    <div>
      <div className="mb-5 flex items-center gap-3">
        <BackButton onClick={onCancel} />
        <h1 className="text-[22px] font-semibold tracking-tight text-gray-900">
          Edit Reminders
        </h1>
      </div>

      <form
        onSubmit={handleSubmit}
        noValidate
        className="space-y-5 rounded-lg border border-gray-100 bg-white p-5 shadow-sm"
      >
        <div className="overflow-x-auto">
          <table className="w-full min-w-[480px] table-auto border-collapse">
            <thead>
              <tr className="border-b text-[10px] uppercase tracking-widest text-gray-500">
                {HEADERS.map((h) => (
                  <th key={h} className="px-3 py-2 text-left font-semibold whitespace-nowrap">
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((row) => (
                <tr key={row.reminder_type}>
                  <td className="px-3 py-2.5 text-xs font-medium text-gray-900 whitespace-nowrap">
                    {row.label}
                  </td>
                  <td className="w-40 px-3 py-2">
                    <SelectMenu
                      name={row.reminder_type}
                      value={row.enabled ? "yes" : "no"}
                      onChange={(e) => setEnabled(row.reminder_type, e.target.value === "yes")}
                      options={YES_NO}
                      menuMinWidth={120}
                      className={`${FIELD_BASE} pr-9 ${fieldState()} text-gray-900`}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="flex gap-2 border-t border-gray-100 pt-3 text-sm">
          <button type="submit" disabled={saving} className={btn("primary", "sm")}>
            {saving ? "Updating..." : "Update"}
          </button>
          <button
            type="button"
            onClick={onCancel}
            disabled={saving}
            className={btn("secondary", "sm")}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default RemindersForm;